import type { RouteRecordRaw } from 'vue-router'
import { api } from '../../services/api' // axios instance
import {ROUTES, API_ENDPOINTS,ImageUploadApi} from '@myorg/type-lib'
import axios from 'axios';

import  ImageUploader  from '../../pages/ImageUploader.vue'

export const r2Route: RouteRecordRaw = {
  path: ROUTES.UPLOAD_R2.PATH,
  name: ROUTES.UPLOAD_R2.NAME,
  component: ImageUploader,
  // props: (route) => ({
  //   imageUploadApi: imageUploadApiImpl,
  // })
}
